export default __webpack_public_path__ + "static/media/Exclamation.bbe5a61f.svg";